module.exports = __webpack_public_path__ + "static/media/n_icon_strategy.432042bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_strategy.png
// module id = 1813
// module chunks = 0 1